import axios from '../axios';

export const validatePhone = async (number) => {
	const res = await axios.get(`/api/phone-number-validation/${encodeURIComponent(number)}`);
	return res.data;
};

export const validateEmail = async (email) => {
	const res = await axios.get(`/api/email-validation?email=${encodeURIComponent(email)}`);
	return res.data;
};
